/**
 * EliorGroup.Joyfood.Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InAppNotificationPriority } from './inAppNotificationPriority';


export interface CreateInAppNotificationCommand { 
    title?: string | null;
    description?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    priority?: InAppNotificationPriority;
    isDraft?: boolean | null;
    companyId?: number | null;
}
export namespace CreateInAppNotificationCommand {
}


